<div class="row">
  <div class="col-md-12">
    <h4>Siniestros</h4>
    <div>
      <generic-table-avla
        [jsonData]="sinesterData"
        [columns]="registrocolumnas"
        [primaryIndexer]="primaryIndexerTableSinester"
        [serverPagination]="false"
        [enableGeneralSearch]="false"
        [editableRow]="false"
        [deletableRow]="false"
        [showReloadButton]="false"
        [showSelectorRowsOnPage]="false"
        [rowsOnPage]="5"
        [textTableEmpty]="'No posee siniestro asociados'"
        [templateColumns]="{
          procedencia: procedenciaTemplate,
          incidencia: incidenciaTemplate
        }"
        [textTableLoading]="'Cargando...'">
      </generic-table-avla>
    </div>
  </div>
</div>
<ng-template
  #procedenciaTemplate
  let-item="item"
  let-col="col"
  let-cellValue="cellValue">
  <span class="badge badge-primary">
    {{ getprocedencia(cellValue) }}
  </span>
</ng-template>

<ng-template
  #incidenciaTemplate
  let-item="item"
  let-col="col"
  let-cellValue="cellValue">
  <span class="badge badge-primary">
    {{ getincidencia(cellValue) }}
  </span>
</ng-template>
